module.exports = __webpack_public_path__ + "static/media/Energizer.d3aed004.svg";